define('Design.ei1.Main.View', [
    'PageType.Base.View',
    'design.tpl',
    'Designrequest.ei1.Main.View'
], function (
    PageTypeBaseView,
    design_tpl,
    DesignRequestView
) {
    'use strict';

    return PageTypeBaseView.PageTypeBaseView.extend({
        template: design_tpl,

        beforeShowContent: function beforeShowContent() {
            this.childViews = {
                'Designrequest.ei1.Main.View': function () {
                    return new DesignRequestView();
                }
            };
            return jQuery.Deferred().resolve();
        }
    });
});
